import AxiosFactory from "@/repositories/AxiosFactory";

const resource = "/irc-state";

export default {
  getIRCState() {
    return AxiosFactory.get(resource);
  }
};
